// To determine if user is main user or just an idp provided user
export const isLoggedInUserAnIdpUser = (jwtDecodedIdToken) => {
  const loggedInUser = jwtDecodedIdToken['cognito:username'];
  const mainUser = jwtDecodedIdToken.mainUserAttributes.username;

  return mainUser !== loggedInUser;
};
